<div class="device-setup-outer">
  <div class="device-step">
    <div class="active-step">
      <div class="step-bullet">
        <span>
          <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g id="Layer_x0020_1">
              <g transform="matrix(0.659889,0,0,0.659889,4.08133,4.08133)">
                <path d="M23.2,6C23,5.9 22.8,5.9 22.7,6L19.2,8.7L19.2,7.5C19.2,5.9 17.9,4.6 16.3,4.6L3.4,4.6C1.8,4.6 0.5,5.9 0.5,7.5L0.5,16.5C0.5,18.1 1.8,19.4 3.4,19.4L16.3,19.4C17.9,19.4 19.2,18.1 19.2,16.5L19.2,15.3L22.7,18C22.8,18.1 23,18.1 23.2,18C23.4,17.9 23.5,17.8 23.5,17.6L23.5,6.4C23.5,6.2 23.4,6.1 23.2,6Z" />
              </g>
            </g>
          </svg>
        </span>
      </div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Video</p>
    </div>

    <div>
      <div class="step-bullet">
        <span>
          <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g id="Layer_x0020_1">
              <g transform="matrix(1,0,0,1,3.986,4)">
                <path d="M8,11C9.657,11 11,9.657 11,8L11,3C11,1.343 9.657,0 8,0C6.343,0 5,1.343 5,3L5,8C5,9.657 6.343,11 8,11Z"/>
              </g>
              <g transform="matrix(1,0,0,1,3.986,4)">
                <path d="M13,8L13,6L12,6L12,7.844C12,9.764 10.718,11.532 8.836,11.915C6.266,12.438 4,10.479 4,8L4,6L3,6L3,8C3,10.414 4.721,12.434 7,12.899L7,15L5,15L5,16L11,16L11,15L9,15L9,12.899C11.279,12.434 13,10.414 13,8Z" />
              </g>
            </g>
          </svg>
        </span>
      </div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Microphone</p>
    </div>

    <div>
      <div class="step-bullet">
        <span>
          <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g id="Layer_x0020_1">
              <g transform="matrix(0.61358,0,0,0.61358,4.63704,4.63704)">
                <g>
                  <path d="M19.779,3.349L18.668,5.013C20.699,6.663 22,9.179 22,12C22,14.822 20.699,17.338 18.668,18.988L19.779,20.651C22.345,18.639 24,15.516 24,12C24,8.485 22.346,5.362 19.779,3.349ZM17.55,6.687L16.428,8.367C17.396,9.28 18.008,10.565 18.008,12.001C18.008,13.437 17.396,14.723 16.428,15.636L17.55,17.316C19.047,16.03 20,14.128 20,12C20,9.873 19.048,7.971 17.55,6.687ZM12,1C10.823,1 10.467,1.684 10.467,1.684C10.467,1.684 7.406,5.047 5.298,6.531C4.91,6.778 4.484,7 3.73,7L2,7C0.896,7 0,7.896 0,9L0,15C0,16.104 0.896,17 2,17L3.73,17C4.484,17 4.91,17.222 5.297,17.469C7.405,18.953 10.466,22.317 10.466,22.317C10.466,22.317 10.823,23 12,23C13.104,23 14,22.105 14,21L14,3C14,1.895 13.104,1 12,1Z" />
                </g>
              </g>
            </g>
          </svg>
        </span>
      </div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Speakers</p>
    </div>

    <div>
      <div class="step-bullet">
        <span>
          <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g id="Layer_x0020_1">
              <path d="M18.185,18L5.787,18C5.485,18 5.199,17.863 5.009,17.628C3.766,16.089 3.021,14.131 3.021,12C3.021,7.052 7.038,3.035 11.986,3.035C16.934,3.035 20.951,7.052 20.951,12C20.951,14.131 20.206,16.089 18.963,17.628C18.773,17.863 18.487,18 18.185,18ZM12.743,5.075L12.743,6.995C12.743,7.412 12.405,7.75 11.988,7.75L11.977,7.75C11.56,7.75 11.222,7.412 11.222,6.995L11.222,5.076C8.943,5.325 6.993,6.676 5.916,8.583L7.657,9.589C8.018,9.797 8.142,10.259 7.934,10.62L7.928,10.63C7.72,10.991 7.258,11.114 6.897,10.906L5.315,9.993C5.123,10.628 5.021,11.302 5.021,12C5.021,13.488 5.488,14.868 6.285,16L9.972,16C9.972,15.042 10.647,14.241 11.547,14.045L14.044,8.72C14.11,8.579 14.27,8.51 14.418,8.558C14.566,8.606 14.655,8.756 14.625,8.909L13.509,14.721C13.798,15.067 13.972,15.514 13.972,16L17.687,16C18.484,14.868 18.951,13.488 18.951,12C18.951,11.301 18.848,10.626 18.656,9.989L17.068,10.906C16.707,11.114 16.245,10.991 16.037,10.63L16.031,10.62C15.823,10.259 15.947,9.797 16.308,9.589L18.054,8.58C16.976,6.672 15.024,5.322 12.743,5.075Z" />
            </g>
          </svg>
        </span>
      </div>
      <div class="check"></div>
      <div class="prog"></div>
      <p>Speed test</p>
    </div>
  </div>

  <div class="device-setup">
    <div>
      <h2>Test your webcam</h2>
      <p>
        Click the webcam icon. You will see a prompt asking you whether or not you want to grant your browser webcam access - please be sure to do so.
        If your webcam is working, you will be able to see yourself below.
      </p>
    </div>

    <div>
      <div id="webcam-video-container">
        <div id="webcam-start"></div>
        <p id="fps-meter"></p>
        <!--<video id="webcam-video"></video>-->
      </div>
      <p id="webcam-info"></p>
    </div>

    <div>
      <button class="btn-full btn-main-proceed" type="button" (click)="setDeviceSetupStage0()">Back</button>
      <button class="btn-full btn-main" type="button" (click)="setDeviceSetupStage2()">Next</button>
    </div>
  </div>
</div>
